import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api, ApiHttpError } from '~/lib/api/client'
import type { Checkin, CheckinUpdatePayload } from '~/lib/api/types'

export const CHECKIN_QUERY_KEY = (id: string) => ['checkin', id] as const

export function useCheckin(id: string | null) {
  return useQuery<Checkin, ApiHttpError>({
    queryKey: id ? CHECKIN_QUERY_KEY(id) : ['checkin', '__none__'],
    queryFn: () => api.getCheckin(id as string),
    enabled: !!id,
    staleTime: 10 * 1000,
  })
}

export function useUpdateCheckin(id: string) {
  const qc = useQueryClient()
  return useMutation<Checkin, ApiHttpError, CheckinUpdatePayload>({
    mutationFn: patch => api.updateCheckin(id, patch),
    onSuccess: saved => {
      qc.setQueryData(CHECKIN_QUERY_KEY(id), saved)
      // Range queries hold the cell view; broadcast invalidation will
      // also flow in via the dashboard channel, but invalidating here is
      // immediate so the calendar reflects the edit on close.
      qc.invalidateQueries({ queryKey: ['snapshot'] })
    },
  })
}
